module.exports = __webpack_public_path__ + "img/3.a457b1d3.jpg";